import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => (
  <main className="flex min-h-[60vh] items-center justify-center bg-black px-5 py-16 text-center text-white">
    <div className="max-w-[620px]">
      <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#EEC24B]">404</p>
      <h1 className="mt-3 text-4xl font-bold text-gradient sm:text-6xl">Page Not Found</h1>
      <p className="mt-5 text-lg leading-relaxed text-white/75">
        The page may have moved or the address may be incorrect.
      </p>
      <Link to="/" className="buttons mt-8 inline-flex min-h-11 items-center justify-center rounded-lg px-6 py-3 font-semibold text-black">
        Return Home
      </Link>
    </div>
  </main>
)

export default NotFound
